<template>
  <div class="open-page">
    <childNav
      :routerName="$t('breadcrumbItem.name')"
      :backFlag="true"
    ></childNav>
    <div class="open-body">
      <div class="open-box">
        <!-- 批量添加 -->
        <div v-if="batchFlag">
          <div class="batch-add">
            <span class="primary-color" @click="toggleBatch"
              ><a>
                {{ $t("openConfig.singleAdd") }}
                <Icon type="md-arrow-round-forward" /></a
            ></span>
          </div>
          <div class="btn-box">
            <div class="left-btn">
              <form id="uploadInfo">
                <div class="form-box">
                  <Button
                    type="primary"
                    class="file big-btn-width"
                    size="large"
                  >
                    {{ $t("openConfig.uploadInfo") }}
                    <input
                      type="file"
                      name="facePic"
                      accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      @change="showInfo($event)"
                    />
                  </Button>
                </div>
              </form>
              <form id="uploadPic">
                <div class="form-box">
                  <Poptip
                    trigger="hover"
                    :content="$t('openConfig.picBtnTip')"
                    v-if="!exportList.length > 0"
                  >
                    <Button
                      type="primary"
                      class="file big-btn-width"
                      size="large"
                      :disabled="!exportList.length > 0"
                    >
                      {{ $t("openConfig.uploadPic") }}
                    </Button>
                  </Poptip>
                  <Button
                    type="primary"
                    class="file big-btn-width"
                    size="large"
                    v-else
                  >
                    {{ $t("openConfig.uploadPic") }}
                    <input
                      type="file"
                      name="facePic"
                      accept=".zip"
                      @change="showPicZip($event)"
                    />
                  </Button>
                </div>
              </form>
              <Button
                size="large"
                type="primary"
                class="big-btn-width"
                ghost
                @click="exportExcel"
                >{{ $t("openConfig.modelBatch") }}</Button
              >
            </div>
            <div class="right-btn">
              <Button size="large" type="primary" @click="openSingleModal">
                <Icon type="md-add" />{{ $t("openConfig.addName") }}</Button
              >
            </div>
          </div>
          <div v-if="hasList" class="List-box">
            <Table
              :columns="columns12"
              stripe
              border
              tooltip-theme="light"
              :data="exportList"
              height="630"
            >
              <template slot="indexName" slot-scope="{ row, index }">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="devType" slot-scope="{ row, index }">
                <span v-if="row.devType == 'IS'">{{
                  $t("openConfig.IS")
                }}</span>
                <span v-else-if="row.devType == 'GU'">{{
                  $t("openConfig.GU")
                }}</span>
                <span v-else-if="row.devType == 'OS1'">{{
                  $t("openConfig.OS1")
                }}</span>
                <span v-else-if="row.devType == 'OS2'">{{
                  $t("openConfig.OS2")
                }}</span>
                <span v-else-if="row.devType == 'OS3'">{{
                  $t("openConfig.OS3")
                }}</span>
              </template>
              <template slot="facePicUrl" slot-scope="{ row, index }">
                <div v-if="row.facePicUrl">
                  <div class="pic-edit">
                    <div class="pic-box">
                      <img :src="row.facePicUrl" class="pic-small" />
                    </div>
                    <form id="uploadEdit">
                      <div class="form-box">
                        <Button type="primary" ghost class="btn-pic file"
                          ><Icon type="md-repeat" />
                          <input
                            type="file"
                            name="facePic"
                            accept=".jpg,.png,.jpeg"
                            @change="showEdit($event, index, row)"
                        /></Button>
                      </div>
                    </form>
                  </div>
                </div>
                <div v-else>
                  <form id="uploadEdit">
                    <div class="form-box">
                      <Button type="primary" ghost class="file"
                        ><Icon type="md-add" />
                        <input
                          type="file"
                          name="facePic"
                          accept=".jpg,.png,.jpeg"
                          @change="showEdit($event, index, row)"
                      /></Button>
                    </div>
                  </form>
                </div>
              </template>
              <template slot="action" slot-scope="{ row, index }">
                <Button type="error" @click="delBatchFile(index)">{{
                  $t("common.delete")
                }}</Button>
              </template>
            </Table>
          </div>
          <div
            v-else
            class="noList-box batch-noList"
            :class="{ 'red-border': checkFile }"
          >
            <img src="../../assets/image/nodata-icon.png" class="img-table" />
            <span>{{ $t("openConfig.noFile") }}</span>
          </div>
          <span class="require-tip" v-if="checkFile">{{
            $t("openConfig.checkFile")
          }}</span>
          <div v-if="!checkFile" class="tip-height"></div>

          <div class="bottom-btn">
            <Button
              size="large"
              type="primary"
              class="big-btn-width"
              @click="submitBatch"
              >{{ $t("openConfig.produce") }}</Button
            >
          </div>
        </div>
        <!-- 单个添加 -->
        <div v-else>
          <div class="batch-add">
            <span class="primary-color" @click="toggleBatch"
              ><a>
                {{ $t("openConfig.batchAdd") }}
                <Icon type="md-arrow-round-forward" /></a
            ></span>
          </div>
          <Form
            ref="addForm"
            :label-width="130"
            :model="addForm"
            label-colon
            :rules="ruleValidate"
          >
            <FormItem :label="$t('openConfig.devType')" prop="devType">
              <Select
                class="select-width"
                v-model="addForm.devType"
                size="large"
                :placeholder="$t('openConfig.devTypeTip')"
              >
                <Option
                  v-for="(item, index) in devTypeList"
                  :key="index"
                  :value="item.value"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem :label="$t('openConfig.room')" prop="room">
              <Input
                v-model="addForm.room"
                size="large"
                :maxlength="24"
                :placeholder="$t('openConfig.roomTip')"
                clearable
                class="select-width"
              />
            </FormItem>
            <FormItem :label="$t('openConfig.name')" prop="name">
              <Input
                v-model="addForm.name"
                size="large"
                :maxlength="10"
                :placeholder="$t('openConfig.nameTip')"
                clearable
                class="select-width"
              />
            </FormItem>

            <FormItem :label="$t('openConfig.pic')">
              <form id="uploadImg">
                <div class="img-box">
                  <div
                    class="img-item"
                    :class="{ 'form-box-margin': facePicUrl !== '' }"
                    v-if="facePicUrl !== ''"
                  >
                    <Badge>
                      <div class="url-box">
                        <img :src="facePicUrl" class="url-img" />
                      </div>
                      <Icon
                        type="md-remove-circle"
                        slot="count"
                        class="close-badge"
                        @click="delImg()"
                      />
                    </Badge>
                  </div>
                  <div class="img-item" v-show="facePicUrl === ''">
                    <div class="form-box">
                      <a href="javascript:;" class="file">
                        <Icon type="md-add" class="add-icon" />
                        <input
                          type="file"
                          name="facePic"
                          accept=".jpg,.png,.jpeg"
                          @change="showPic($event)"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </form>
            </FormItem>
          </Form>
          <div class="bottom-btn">
            <Button
              ghost
              size="large"
              type="primary"
              class="btn-width"
              @click="resetForm"
              >{{ $t("openConfig.reset") }}</Button
            >
            <Button
              size="large"
              type="primary"
              class="btn-width"
              @click="addPicForm"
              >{{ $t("openConfig.add") }}</Button
            >
          </div>
          <div v-if="hasList" class="List-box">
            <Table
              :columns="columns12"
              stripe
              border
              tooltip-theme="light"
              :data="dataList"
              height="320"
            >
              <template slot="indexName" slot-scope="{ row, index }">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="devType" slot-scope="{ row, index }">
                <span v-if="row.devType == 'IS'">{{
                  $t("openConfig.IS")
                }}</span>
                <span v-else-if="row.devType == 'GU'">{{
                  $t("openConfig.GU")
                }}</span>
                <span v-else-if="row.devType == 'OS1'">{{
                  $t("openConfig.OS1")
                }}</span>
                <span v-else-if="row.devType == 'OS2'">{{
                  $t("openConfig.OS2")
                }}</span>
                <span v-else-if="row.devType == 'OS3'">{{
                  $t("openConfig.OS3")
                }}</span>
              </template>
              <template slot="facePicUrl" slot-scope="{ row, index }">
                <div v-if="row.facePicUrl">
                  <div class="pic-box">
                    <img :src="row.facePicUrl" class="pic-small" />
                  </div>
                </div>

                <div v-else>
                  <span>-</span>
                </div>
              </template>
              <template slot="action" slot-scope="{ row, index }">
                <Button type="error" @click="delFile(index)">{{
                  $t("common.delete")
                }}</Button>
              </template>
            </Table>
          </div>
          <div v-else class="noList-box" :class="{ 'red-border': checkFile }">
            <img src="../../assets/image/nodata-icon.png" class="img-table" />
            <span>{{ $t("openConfig.noFile") }}</span>
          </div>
          <span class="require-tip" v-if="checkFile">{{
            $t("openConfig.checkFile")
          }}</span>
          <div v-if="!checkFile" class="tip-height"></div>

          <div class="bottom-btn">
            <Button
              size="large"
              type="primary"
              class="big-btn-width"
              @click="submitForm"
              >{{ $t("openConfig.produce") }}</Button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="content_win">
      <addNameModal
        ref="addNameModal"
        @getList="handleSingle($event)"
      ></addNameModal>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import JSZip from "jszip";
import saveAs from "file-saver";
import addNameModal from "./addNameModal.vue";
import childNav from "@/components/homeNav/childNav.vue";
export default {
  name: "openList",
  components: {
    addNameModal,
    childNav,
  },
  data() {
    return {
      focusPage: "1",
      addForm: {},
      ruleValidate: {
        name: [
          {
            required: true,
            message: this.$t("openConfig.checkName"),
            trigger: "blur",
          },
        ],
        room: [
          {
            required: true,
            message: this.$t("openConfig.checkRoom"),
            trigger: "blur",
          },
        ],
        devType: [
          {
            required: true,
            message: this.$t("openConfig.checkDevType"),
            trigger: "change",
            type: "string",
          },
        ],
      },

      columns12: this.global.nameColumns12,
      devTypeList: this.global.devTypeList,
      dataList: [],
      exportList: [],
      hasList: false,
      checkFile: false,
      facePicUrl: "",
      batchFlag: true,
      enFlag: false,
    };
  },
  watch: {
    dataList: {
      handler() {
        if (this.dataList.length > 0) {
          this.hasList = true;
          this.checkFile = false;
        } else {
          this.hasList = false;
        }
      },
    },
    exportList: {
      handler() {
        if (this.exportList.length > 0) {
          this.hasList = true;
          this.checkFile = false;
        } else {
          this.hasList = false;
        }
      },
    },
  },
  mounted() {
    let lang = localStorage.getItem("language");
    if (lang == "zh") {
      this.enFlag = false;
    } else if (lang == "en") {
      this.enFlag = true;
    }
  },
  methods: {
    //  从系统文件选择图片
    showPic($event) {
      let el = $event.currentTarget;
      let file = el.files[0];

      // 检验格式
      let lastName = file.name.split(".").reverse()[0];
      let allowPicReg = ["jpg", "png", "jpeg"];
      if (!allowPicReg.includes(lastName)) {
        this.$Message.error(this.$t("openConfig.imgRegTip"));
        file = this.currentFile;
      } else {
        let url = null;
        this.currentFile = file;
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        }

        this.facePicUrl = url;

        this.addForm.pic = el.files[0];
        this.addForm.facePicUrl = url;

        this.$forceUpdate();
      }
    },
    // 删除人脸
    delImg() {
      this.facePicUrl = "";
      this.addForm.pic = null;
      this.addForm.facePicUrl = "";
      document.getElementById("uploadImg").reset();
    },
    // 添加名字列表
    addPicForm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let obj = {
            name: this.addForm.name,
            room: this.addForm.room,
            devType: this.addForm.devType,
          };
          if (this.addForm.pic) {
            let lastName = this.addForm.pic.name.split(".").reverse()[0];
            let fileName = this.addForm.room + "." + lastName;
            obj.fileName = fileName;
            obj.pic = this.addForm.pic;
            obj.facePicUrl = this.addForm.facePicUrl;
          }
          this.dataList.push(obj);
        }
      });
    },
    // 重置表单
    resetForm() {
      this.$refs.addForm.resetFields();
      this.addForm = {};
      this.delImg();
    },
    // 删除文件
    delFile(index) {
      this.dataList.splice(index, 1);
    },

    //  提交表单
    submitForm() {
      if (this.dataList.length > 0) {
        // 判断 添加的房号是否有重复
        let delList = JSON.parse(JSON.stringify(this.dataList)).reverse();
        let sameList = [];
        delList.filter((item, index, self) => {
          for (let i = index + 1; i < self.length; i++) {
            if (self[i].room == item.room) {
              sameList.push(Math.abs(index - delList.length));
              return true;
            }
          }
          return false;
        });
        if (sameList.length > 0) {
          let str =
            this.$t("openConfig.sameTip") +
            sameList.reverse().toString() +
            this.$t("openConfig.sameTip1");
          this.$Message.error({
            message: str,
          });
        } else {
          let arr = [];
          let zip = new JSZip();
          // 新建文件夹 img
          let img = zip.folder("img");

          this.dataList.map((item, index) => {
            let obj = {
              index: index + 1,
              devType: item.devType,
              name: item.name,
              room: item.room,
            };
            if (item.pic) {
              obj.img = "/img/" + item.fileName;
              //   添加图片到文件夹
              img.file(item.fileName, item.pic, { base64: true });
            } else {
              obj.img = "";
            }
            arr.push(obj);
          });
          let jsonStr = JSON.stringify(arr);
          // 将conf内容添加
          zip.file("conf.json", jsonStr);
          // 生成压缩包 并提供下载
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, "name_list.zip");
          });
        }
      } else {
        this.checkFile = true;
      }
    },
    // 修改状态批量-单个
    toggleBatch() {
      this.batchFlag = !this.batchFlag;
      if (this.batchFlag) {
        // 重置单个页面
        this.dataList = [];
        this.checkFile = false;
        this.resetForm();
      } else {
        document.getElementById("uploadInfo").reset();
        document.getElementById("uploadPic").reset();
        this.exportList = [];
        this.checkFile = false;
      }
    },
    // 导出模板
    exportExcel() {
      const excelData = [
        { 排序: "", 设备类型: "", 设备编号: "", 名字: "", 图片名称: "" },
      ];
      const excelDataEn = [
        {
          sort: "",
          "Device type": "",
          "Device number": "",
          name: "",
          "Picture name": "",
        },
      ];
      let workbook = XLSX.utils.book_new();
      let sheet2 = "";
      if (this.enFlag) {
        sheet2 = XLSX.utils.json_to_sheet(excelDataEn);
      } else {
        sheet2 = XLSX.utils.json_to_sheet(excelData);
      }

      XLSX.utils.book_append_sheet(workbook, sheet2, "sheetName2"); //工作簿名称
      XLSX.writeFile(workbook, "name_list_sc.xlsx");
    },
    //  上传基础信息
    showInfo($event) {
      let _this = this;
      let el = $event.currentTarget;
      let f = el.files[0];
      // 检验格式
      let lastName = f.name.split(".").reverse()[0];
      let allowPicReg = ["xls", "xlsx"];
      if (!allowPicReg.includes(lastName)) {
        this.$Message.error(this.$t("openConfig.excRegTip"));
      } else {
        // 使用 FileReader 读取数据
        let reader = new FileReader();
        // 数据读取完成后的回调函数
        reader.onload = function (e) {
          // 获取文件二进制数据流
          let data = e.currentTarget.result;

          // 利用XLSX解析二进制文件为xlsx对象
          let wb = XLSX.read(data, { type: "binary" });

          const firstSheetName = wb.SheetNames[0]; // 获取第一个 sheet 的名字
          const worksheet = wb.Sheets[firstSheetName]; // 获取第一个 sheet 的内容

          const res = XLSX.utils.sheet_to_json(worksheet); // 使用 utils 里的方法转换内容为便于使用的数组

          // 判断上传文件是否为 name room

          let keyList = Object.getOwnPropertyNames(res[0]);

          if (keyList[1] == "排序" && keyList[2] == "设备类型") {
            // 模板正确
            // 将 key 切换为 变量
            const mapInfo = {
              排序: "index",
              设备类型: "devType",
              设备编号: "room",
              名字: "name",
              图片名称: "picName",
            };
            let resetArr = [];
            let nameTip = false;
            let numTip = false;
            res.map((obj) => {
              console.log(obj);
              if (!obj["名字"]) {
                obj["名字"] = "";
              }

              if (!obj["设备编号"]) {
                obj["设备编号"] = "";
              }
              let zhobj = {};
              //Object.keys(obj)之后会获得一个数组
              let nameFlag = false;
              let numFlag = false;
              Object.keys(obj).forEach((zhkey) => {
                let enkey = mapInfo[zhkey];
                zhobj[enkey] = obj[zhkey];

                if (
                  (obj["名字"] == "" || obj["名字"] == undefined) &&
                  zhkey == "名字"
                ) {
                  nameFlag = true;
                }

                if (
                  (obj["设备编号"] == "" || obj["设备编号"] == undefined) &&
                  zhkey == "设备编号"
                ) {
                  numFlag = true;
                }
              });

              if (!nameFlag && !numFlag) {
                zhobj.room = zhobj.room + ""; // 配合设备端将房间号修改为字符串类型
                resetArr.push(zhobj);
              }
              if (nameFlag) {
                nameTip = true;
              }
              if (numFlag) {
                numTip = true;
              }
            });
            if (nameTip) {
              _this.$Message.error(_this.$t("openConfig.nameListTip"));
            }

            setTimeout(() => {
              if (numTip) {
                _this.$Message.error(_this.$t("openConfig.numListTip"));
              }
            }, 100);

            // 判断 批量添加的房号是否有重复
            _this.exportList = _this.exportList.concat(resetArr);
            let delList = JSON.parse(
              JSON.stringify(_this.exportList)
            ).reverse();

            let sameList = [];
            delList.filter((item, index, self) => {
              for (let i = index + 1; i < self.length; i++) {
                if (self[i].room == item.room) {
                  sameList.push(Math.abs(index - delList.length));
                  return true;
                }
              }
              return false;
            });
            if (sameList.length > 0) {
              let str =
                _this.$t("openConfig.sameTip") +
                sameList.reverse().toString() +
                _this.$t("openConfig.sameTip1");
              setTimeout(() => {
                _this.$Message.error({
                  message: str,
                });
              }, 200);
            }

            _this.$forceUpdate();
          } else {
            setTimeout(() => {
              _this.$Message.error(_this.$t("openConfig.modelError"));
            }, 200);
          }

          document.getElementById("uploadInfo").reset();
        };
        reader.readAsBinaryString(f);
      }
    },
    // 上传图片包
    showPicZip($event) {
      let el = $event.currentTarget;
      const zipFile = el.files[0];
      // 检验格式
      let lastName = zipFile.name.split(".").reverse()[0];
      let allowPicReg = ["zip"];
      if (!allowPicReg.includes(lastName)) {
        this.$Message.error(this.$t("openConfig.zipRegTip"));
      } else {
        let list = JSON.parse(JSON.stringify(this.exportList));
        const jszip = new JSZip();
        jszip.loadAsync(zipFile).then((zip) => {
          // 读取zip
          for (let key in zip.files) {
            // 判断是否是目录
            if (!zip.files[key].dir) {
              if (/\.(png|jpg|jpeg)$/.test(zip.files[key].name)) {
                // 判断是否是图片格式
                let base = zip.file(zip.files[key].name).async("base64"); // 将图片转化为base64格式
                base.then((res) => {
                  let lastName = zip.files[key].name.split("/").reverse()[0]; // 123.jpg
                  let name = lastName.split(".").reverse()[1]; // 123
                  list.map((item, k) => {
                    if (item.picName == name) {
                      let obj = {
                        fileName: lastName,
                        type: "img",
                        content: `data:image/png;base64,${res}`,
                      };
                      item.pic = this.dataURLtoFile(obj.content, lastName);
                      item.facePicUrl = obj.content;
                      this.$set(this.exportList[k], "facePicUrl", obj.content);
                      this.$set(this.exportList[k], "pic", item.pic);

                      this.$forceUpdate();
                    }
                  });
                });
              }
            }
          }
        });
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    // 提交
    submitBatch() {
      if (this.exportList.length > 0) {
        // 判断 添加的房号是否有重复
        let delList = JSON.parse(JSON.stringify(this.exportList)).reverse();
        let sameList = [];
        delList.filter((item, index, self) => {
          for (let i = index + 1; i < self.length; i++) {
            if (self[i].room == item.room) {
              sameList.push(Math.abs(index - delList.length));
              return true;
            }
          }
          return false;
        });
        if (sameList.length > 0) {
          let str =
            this.$t("openConfig.sameTip") +
            sameList.reverse().toString() +
            this.$t("openConfig.sameTip1");
          this.$Message.error({
            message: str,
          });
        } else {
          let arr = [];
          let zip = new JSZip();
          // 新建文件夹 img
          let img = zip.folder("img");
          this.exportList.map((item, index) => {
            let obj = {
              index: index + 1,
              devType: item.devType,
              name: item.name,
              room: item.room,
            };
            if (item.pic) {
              if (item.fileName) {
                obj.img = "/img/" + item.fileName;
                img.file(item.fileName, item.pic, { base64: true });
              } else {
                obj.img = "/img/" + item.pic.name;
                img.file(item.pic.name, item.pic, { base64: true });
              }
            } else {
              obj.img = "";
            }

            arr.push(obj);
          });
          let jsonStr = JSON.stringify(arr);
          // 将conf内容添加
          zip.file("conf.json", jsonStr);
          // 生成压缩包 并提供下载
          zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, "name_list.zip");
          });
        }
      } else {
        this.checkFile = true;
      }
    },

    // 打开弹窗
    openSingleModal() {
      this.$refs.addNameModal.dialogVisible = true;
    },
    // 处理单条数据
    handleSingle(obj) {
      this.exportList.push(obj);
    },
    //  批量页删除名字
    delBatchFile(index) {
      this.exportList.splice(index, 1);
    },
    showEdit($event, index, row) {
      let el = $event.currentTarget;
      let file = el.files[0];
      let lastName = file.name.split(".").reverse()[0];
      let allowPicReg = ["jpg", "png", "jpeg"];
      if (!allowPicReg.includes(lastName)) {
        this.$Message.error(this.$t("openConfig.imgRegTip"));
        file = this.currentFile;
      } else {
        let url = null;
        this.currentFile = file;
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file);
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file);
        }

        this.$set(this.exportList[index], "fileName", null);
        this.$set(this.exportList[index], "pic", file);
        this.$set(this.exportList[index], "facePicUrl", url);

        this.$forceUpdate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.open-page {
  .open-body {
    .open-box {
      height: 830px;
      padding: 30px 60px;
      .required-span {
        left: 31.5%;
      }
      .pic-require {
        position: relative;
        left: 15%;
        top: -20px;
      }
      .noList-box {
        margin: 20px 0 0;
      }
      .batch-add {
        text-align: right;
        line-height: 20px;
      }
      .btn-box {
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        margin-top: 10px;
        .left-btn {
          display: flex;
          flex-direction: row;
          .big-btn-width {
            margin-right: 20px;
          }
          .btn-tip {
            display: inline-block;
          }
        }
        .right-btn {
          text-align: right;
        }
      }
      .batch-noList {
        height: 630px;
      }
      .margin-top-20 {
        margin-top: 20px;
      }
      .List-box {
        .pic-edit {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .btn-pic {
            margin-left: 15px;
          }
        }
      }
    }
  }
}
</style>
